import React from 'react'
import PropTypes from 'prop-types'

const StudentEntries = props => {
  const { updateModal, fetchModalBody, isPercentFormat, activities, entries } =
    props

  let prepareModal = (activityID, activityTitle, studentID) => {
    updateModal({
      modalBody: null,
      showModal: true,
      selectedActivity: {
        title: activityTitle,
        id: activityID,
      },
    })
    fetchModalBody(activityID, studentID)
  }

  let generateActivityGrade = (entry, activity) => {
    if (entry.grades[activity.id] == null) {
      const clickHandler = () =>
        prepareModal(activity.id, activity.title, entry.student.pk)
      return (
        <td
          key={activity.id}
          className="customtable_studentid customtable_cell"
        >
          <div
            className="customtable_data_span gradebook_cell"
            onClick={clickHandler}
            data-activity-id={`${activity.id}`}
          />
        </td>
      )
    }

    const { points, totalPoints } = entry.grades[activity.id]
    const fPoints = parseFloat(points || 0)
    const fTotalPoints = parseFloat(totalPoints || 0)
    const percentage =
      fTotalPoints === 0 || Number.isNaN(fTotalPoints)
        ? null
        : ((fPoints / fTotalPoints) * 100).toFixed(2)

    let gradeColor
    if (percentage < 60) {
      gradeColor = 'grade_color_maroon'
    } else if (percentage < 80) {
      gradeColor = 'grade_color_orange'
    } else {
      gradeColor = 'grade_color_green'
    }

    const formattedScore = isPercentFormat ? (
      <a className={`assessment-view-percentage ${gradeColor}`}>
        {percentage}%
      </a>
    ) : (
      <a className={`assessment-view-score ${gradeColor}`}>{points}</a>
    )

    const clickHandler = () =>
      prepareModal(activity.id, activity.title, entry.student.pk)

    return (
      <td
        key={`${activity.id}-${entry.student.pk}`}
        className="customtable_cell customtable_data"
      >
        <div
          className="customtable_data_span gradebook_cell"
          onClick={clickHandler}
          data-activity-id={`${activity.id}`}
        >
          {formattedScore}
        </div>
      </td>
    )
  }

  return (
    <table>
      <tbody>
        {entries.map(entry => {
          return (
            <tr key={entry.student.pk} className="customtable_row">
              <td className="customtable_email customtable_cell">
                <div className="gradebook_cell">
                  <a href={`mailto:${entry.student.email}`}>
                    {entry.student.email}
                  </a>
                </div>
              </td>
              <td className="customtable_signup customtable_cell">
                <div className="gradebook_cell">{entry.student.signupDate}</div>
              </td>
              <td className="customtable_section customtable_cell">
                <div className="gradebook_cell">{entry.student.section}</div>
              </td>
              <td className="customtable_studentid customtable_cell">
                <div className="gradebook_cell">{entry.student.schoolId}</div>
              </td>
              {activities.map(activity =>
                generateActivityGrade(entry, activity)
              )}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

StudentEntries.propTypes = {
  activities: PropTypes.array.isRequired,
  entries: PropTypes.array.isRequired,
  isPercentFormat: PropTypes.bool.isRequired,
  fetchModalBody: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
}

export default StudentEntries
